import _ from 'lodash'
// import { createSelector } from 'reselect'

export const getLeadFollowUps = state =>
  _.get(state, 'leadFollowUpActions.leadFollowUps.data', null)

export const getFollowUpIdParam = (state, props) =>
  parseInt(_.get(props, 'match.params.followUpId', null), 10)



// WEBPACK FOOTER //
// ./src/selectors/lead/followups.js